module.exports = __webpack_public_path__ + "./docs/img/icon-member.7b7d2533caffcb70a020cf7fc80471bd.svg";